import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class FaceRightInstruction extends Instruction<"face-right"> {
  readonly type = "face-right";

  act(context: ProgramModel) {
    context.cursorDirection = "right";
  }
}
